<script setup lang="ts">
const documentId = inject("documentId") as any;

const submittedDocumentStore = useSubmittedDocumentStore(documentId);
const { submittedDocument } = storeToRefs(submittedDocumentStore);

const documentViewModeStore = useDocumentViewModeStore(documentId);
const { isTeacherViewMode } = storeToRefs(documentViewModeStore);



</script>

<template>
  <div v-if="isTeacherViewMode" class="flex flex-col border rounded p-2">
    {{ submittedDocument }}
  </div>
</template>

<style scoped></style>
